import { useEffect } from 'react';
// import { getIndexClass, getNextIndex, getTargetElement } from './helpers';

const useElementsNavigation = () => {
  // const handleKeyDown = (e: KeyboardEvent) => {
  //   const indexClass = getIndexClass();
  //   if (!indexClass) {
  //     const activeElement = document.getElementsByClassName('index-element-1')[0] as HTMLElement;
  //     if (activeElement) {
  //       getTargetElement(activeElement).focus();
  //     }
  //   } else {
  //     const indexElementNumber = indexClass[indexClass.length - 1];
  //     const nextActiveIndex = getNextIndex(e.code, Number(indexElementNumber));
  //     const nextActiveElement = document.getElementsByClassName(`index-element-${nextActiveIndex}`)[0] as HTMLElement;
  //     if (!nextActiveElement) return;
  //     // TODO: нужно исправить баг с навигацией по семплу
  //     // getTargetElement(nextActiveElement).focus();
  //   }
  // };

  useEffect(() => {
    // TODO: нужно исправить баг с навигацией по семплу
    // document.addEventListener('keydown', (e) => handleKeyDown(e))

    return () => {
      // TODO: нужно исправить баг с навигацией по семплу
      // document.addEventListener('keydown', (e) => handleKeyDown(e))
    };
  }, [])
}

export default useElementsNavigation;
